<template>
  <div class="tabs-card flex-box align-center" :class="[size]" :style="{ '--gap': gap + 'px' }">
    <div
      class="card-tab-item"
      :class="{ active: item.value === value }"
      v-for="item in list"
      :key="item.value"
      @click="selectTab(item)"
    >
      {{ item.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: "TabsCard",
  props: {
    list: { type: Array, default: () => [] },
    value: { type: [Number, String] },
    size: { type: String, default: "default" },
    gap: { type: Number, default: 23 },
  },
  data() {
    return {};
  },
  methods: {
    selectTab(item) {
      this.$emit("input", item.value);
    },
  },
};
</script>

<style lang="less" scoped>
.tabs-card {
  padding-bottom: 15px;
  &.small {
    padding-bottom: 10px;
    .card-tab-item {
      size: 15px;
      padding: 2px 0 4px;
    }
  }
  &.mini {
    padding-bottom: 10px;
    .card-tab-item {
      font-size: 13px;
      padding: 2px 0 4px;
    }
  }
}
.card-tab-item {
  color: #fff;
  font-family: "Source Han Sans CN";
  font-size: 18px;
  font-weight: 700;
  padding: 4px 0 6px;
  white-space: nowrap;
  cursor: pointer;
  &:hover {
    color: var(--primary-color);
  }
  &:not(:last-of-type) {
    margin-right: var(--gap);
  }
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 0;
    height: 2px;
    transform: translateX(-50%);
    background-color: var(--primary-color);
    transition: all 0.2s;
  }
  &.active {
    position: relative;
    color: var(--primary-color);
    &::after {
      width: 100%;
    }
  }
}
</style>
